import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import CascaderHelper, {CascaderOptionInterface} from "~/core-ui/ts/CascaderHelper";


const __default__ = {
    name: "MyCascader"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    options: {},
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel<string>(__props, "modelValue");


return (_ctx: any,_cache: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createBlock(_component_el_cascader, {
    "model-value": _unref(CascaderHelper).idToCascaderValue(_unref(props).options, _unref(model)),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) //@ts-ignore
 ? model.value = _unref(CascaderHelper).cascaderValueToId($event) : model = _unref(CascaderHelper).cascaderValueToId($event))),
    options:  _unref(CascaderHelper).createOptions(_unref(props).options),
    disabled: __props.disabled,
    filterable: "",
    "filter-method": _unref(CascaderHelper).filterMethod,
    class: "w-100"
  }, null, 8, ["model-value", "options", "disabled", "filter-method"]))
}
}

})